// extracted by mini-css-extract-plugin
module.exports = {"popupContainer":"Popup_popupContainer__OQbSH","spyElement":"Popup_spyElement___z4c6","nonFocusableOutline":"Popup_nonFocusableOutline__fZ02u"};